import { UsersGroupList } from "./UsersGroupList";

export default UsersGroupList;
